import { Injectable } from '@angular/core';
import {
  getValue,
  isDefined,
  isDefinedAndFilledArray,
  isDefinedAndFilledString,
} from '../../../../shared/utility/verify.lib';
import { IDocumentTypeText } from '../../../../models/document/document-type-text.model';
import { IExportConfiguration } from '../../../../models/export/export-configuration.model';
import { IExportStructure } from '../../../../models/export/export-structure.model';

@Injectable({
  providedIn: 'root',
})
export class TrackingPreparationService {
  private readonly filePrefix: string = 'fi_';
  private readonly folderPrefix: string = 'fo_';

  public constructor() {}

  public getDocumentTypeText(
    documentTypeTexts: IDocumentTypeText[],
    separator: string
  ): string {
    let docTypesTracking: string = '';

    if (isDefinedAndFilledArray(() => documentTypeTexts)) {
      documentTypeTexts.forEach((documentText: IDocumentTypeText) => {
        if (this.isLastCharNotEqualSeparator(docTypesTracking, separator)) {
          docTypesTracking += separator;
        }
        docTypesTracking +=
          getValue(() => documentText.text, '') +
          getValue(() => documentText.docTypeId, '');
      });
    }

    return docTypesTracking;
  }

  public getFolderFileText(
    savedConfiguration: IExportConfiguration,
    separator: string,
    addLevel: boolean
  ): string {
    let folderFileText: string = '';

    folderFileText += this.getFolderFileTextFromList(
      savedConfiguration.folderSetting,
      this.folderPrefix,
      separator,
      addLevel
    );
    folderFileText += isDefinedAndFilledString(() => folderFileText)
      ? separator
      : '';
    folderFileText += this.getFolderFileTextFromList(
      savedConfiguration.fileSetting,
      this.filePrefix,
      separator,
      addLevel
    );

    return folderFileText;
  }

  public getFilledExportLevel(
    savedConfiguration: IExportConfiguration
  ): string {
    let filledExportLevel: string = '';

    filledExportLevel += this.getFilledExportLevelFromList(
      savedConfiguration.folderSetting,
      this.folderPrefix
    );
    filledExportLevel += isDefinedAndFilledString(() => filledExportLevel)
      ? ';'
      : '';
    filledExportLevel += this.getFilledExportLevelFromList(
      savedConfiguration.fileSetting,
      this.filePrefix
    );

    return filledExportLevel;
  }

  private getFolderFileTextFromList(
    settings: IExportStructure[],
    settingText: string,
    separator: string,
    addLevel: boolean
  ): string {
    let composedText: string = '';

    if (isDefinedAndFilledArray(() => settings)) {
      settings.forEach((setting: IExportStructure) => {
        if (isDefined(() => setting.shortName)) {
          if (this.isLastCharNotEqualSeparator(composedText, separator)) {
            composedText += separator;
          }
          composedText += settingText + setting.shortName;
          if (isDefinedAndFilledString(() => setting.level) && addLevel) {
            composedText += '[' + setting.level + ']';
          }
        }
      });
    }

    return composedText;
  }

  private getFilledExportLevelFromList(
    settings: IExportStructure[],
    settingText: string
  ): string {
    let composedText: string = '';
    const separator: string = ';';

    if (isDefinedAndFilledArray(() => settings)) {
      settings.forEach((setting: IExportStructure) => {
        if (isDefined(() => setting.level)) {
          if (this.isLastCharNotEqualSeparator(composedText, separator)) {
            composedText += separator;
          }
          composedText += settingText + 'level' + setting.level;
        }
      });
    }

    return composedText;
  }

  private isLastCharNotEqualSeparator(
    text: string,
    separator: string
  ): boolean {
    return (
      isDefinedAndFilledString(() => text) &&
      text.charAt(text.length - 1) !== separator
    );
  }
}
